import { type ComponentType } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

import { ErrorCard } from "@/components/error-card";
import { usePageTitle } from "@/hooks/use-title";
import { AppRoute } from "@/types/routes";

import { MicropaymentFetcher } from "./fetchers/micropayment-fetcher";
import { MileageFetcher } from "./fetchers/mileage-fetcher";
import { ReceiptFetcher } from "./fetchers/receipt-fetcher";
import { StipendFetcher } from "./fetchers/stipend-fetcher";

import type { PaymentKind } from "./types";

interface PaymentDetailsPageProps {
  paymentKind: PaymentKind;
}

const FETCHER: Record<PaymentKind, ComponentType<{ id: string }>> = {
  mileage: MileageFetcher,
  receipt: ReceiptFetcher,
  micropayment: MicropaymentFetcher,
  stipend: StipendFetcher,
};

export const PaymentDetailsPage = ({
  paymentKind,
}: PaymentDetailsPageProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  usePageTitle(t("payment_title"));

  if (!id?.trim()) {
    return (
      <ErrorCard
        title={t("error")}
        message={t("error_somethingWentWrong")}
        buttonLabel={t("home_claimButtonTitle")}
        onButtonClick={() => navigate(AppRoute.PAYMENTS)}
      />
    );
  }

  const Fetcher = FETCHER[paymentKind];
  return <Fetcher id={id} />;
};
